import {Tooltip} from "../tooltip/tooltip";
import {Tabs} from "../tabs/tabs";
import {Map} from "../map/map";
import { type } from "jquery";

class Cart {

  constructor(elem) {
    this.cart = elem;
    this.product = $('[data-product-size]');
    this.adress = this.cart.find('[data-order-adress]');
    this.adressSet = $('[data-order-adress-set]');
    this.changeAdress = $('[data-cart-item-delivery-change]');
    this.tabsOrder = $('[data-order-delivery]');
    this.saleEL = $('[data-delivery-sale]');
    this.card = this.cart.find('[data-card]');
    this.cardCount = this.card.find('[data-delivery-product-count]');
    this.cardRemove = this.card.find('[data-card-remove]');
    this.cardChangeSize = this.card.find('[data-cart-change-size]');
    this.cartCount = $('[data-cart-count]');
    this.accessories = $('[data-card-accessories]');
    this.fittingSizesAdd = $('[data-fitting-sizes-add]');
    this.deliveryType = $('[data-order-delivery]');
    this.paysystemType = $('[data-radio-pay]');
    // this.cardRemove = $('[data-card-remove]');
    this.url = this.cart.data('url');

    this.sale = this.cart.find('[data-delivery-sale]:checked').attr('data-delivery-sale');
    this.delivery = parseInt(this.cart.find('[data-order-delivery]:checked').attr('data-order-delivery-price'));
	}

  initialize() {
    $('[data-size-button]').on('mouseover', function(e) {
      if ($(window).width() > 991) {
        let trg = e.currentTarget;
        let size = $('.sizes')[0];
        let tooltip = $(trg).siblings('[data-tooltip]')[0]

        if(tooltip) {

          tooltip.style.left = "50%"

          if(tooltip.getBoundingClientRect().right > size.getBoundingClientRect().right) {
            tooltip.style.left = "-100%"
          }

          else if (tooltip.getBoundingClientRect().left < size.getBoundingClientRect().left) {
            $(tooltip).offset({left: $(size).offset().left});
          }
        }
      }
    });
	}

  initializeCart() {
    let index = 0;
    let that = this;
    $(document).on('click', '[data-user-city-basket]', function() {
      $.magnificPopup.open({
        items: {
          src: '#popup-city'
        },
        type:'inline',
        midClick: true,
        closeMarkup: '<button title="%title%" type="button" class="mfp-close popup__close close"></button>',
        removalDelay: 500, //delay removal by X to allow out-animation
        callbacks: {
          beforeOpen: function() {
            this.st.mainClass = 'mfp-zoom-in';
          }
        }
      });
    })


    this.adress.on('click', function(e) {
      let el = $(this);
      let tabs = el.closest('[data-tabs-delivery]').children('[data-tabs-head]').find('.active');

      let code = el.attr('data-shop');
      let city = $('[data-header]').find('[data-user-city]').text();
      let delivery = $('#ORDER_FORM').find('input[name="DELIVERY_ID"]:checked').attr('data-order-delivery');
      let street = el.children().eq(0).text();

      index = el.closest('[data-cart-item]').index();

      $.magnificPopup.open({
        items: {
          src: '#popup-order-adress'
        },
        type:'inline',
        midClick: true,
        closeMarkup: '<button title="%title%" type="button" class="mfp-close popup__close close"></button>',
        removalDelay: 500, //delay removal by X to allow out-animation
        callbacks: {
          beforeOpen: function() {
            this.st.mainClass = 'mfp-zoom-in mfp-modal';
          },
          open: function() {
            $('#popup-order-adress').find('[data-address-order]').text(`${delivery} по адресу: г. ${city}, ${street}`)
            $('#popup-order-adress').find('[data-order-adress-set]').attr('data-code', code)
            $('#popup-order-adress').find('[data-order-adress-set]').attr('data-street', street)
          }
        }
      });

      e.preventDefault();
    });

    this.adressSet.on('click', function(e) {
      let el = $(this);
      let tabs = $('[data-tabs-delivery]').children('[data-tabs-head]').find('.active');
      let adress = el.closest('#popup-order-adress').find('[data-address-order]').text();

      let code = el.attr('data-code')
      let street = el.attr('data-street')
      index = tabs.index();
      let info = $('[data-cart-item]').eq(index).find('[data-cart-item-delivery]');

      info.find('[data-cart-item-delivery-text]').text(adress);
      info.addClass('active');

      info.prev().hide()

      $('#ORDER_PROP_' + window.orderProps['STORE_ID']).val(code);
      $('#ORDER_PROP_' + window.orderProps['F_ADDRESS']).val(street);

      $.magnificPopup.close();

      e.preventDefault();
    });

    this.changeAdress.on('click', function(e) {
      let el = $(this);

      index = el.closest('[data-cart-item]').index();
      let info = $('[data-cart-item]').eq(index).find('[data-cart-item-delivery]');
      $('#ORDER_PROP_' + window.orderProps['STORE_ID']).val('');
      $('#ORDER_PROP_' + window.orderProps['F_ADDRESS']).val('');
      info.removeClass('active');
      info.prev().show();

      e.preventDefault();
    });

    this.tabsOrder.closest('[data-tabs-head]').children().on('click', function(e) {
      let el = $(this);
      let tabs = el.closest('[data-tabs]');

      if (el.find('input[type="radio"]').length > 0) {
        let radio = el.find('input[type="radio"]');
        tabs.find('input[type="radio"]').prop('checked', false);
        radio.prop('checked', true);

        if (radio.is('[data-order-delivery]')) {
          let attr = radio.attr('data-order-delivery');
          let price = radio.attr('data-order-delivery-price');

          $('[data-total-delivery]').text(attr);
          $('[data-total-delivery-price]').text(price);

          if (attr == 'Получить в магазине') {
            $('[data-notify-cart]').removeClass('d-none');
            $('[data-promo-cart]').addClass('d-none');
            $('[data-bonus-cart]').addClass('d-none');
            $('[data-aeroflot-cart]').addClass('d-none');
            $('[data-radio-pay="online"]').prop('disabled', true);
            $('[data-radio-pay="online"]').prop('checked', false);
            $('[data-radio-pay="sale"]').prop('checked', true);
            $('[data-order-text]').text('Ожидайте подтверждение наличия товара в выбранном магазине.')
          } else {
            $('[data-notify-cart]').addClass('d-none');
            $('[data-promo-cart]').removeClass('d-none');
            $('[data-bonus-cart]').removeClass('d-none');
            $('[data-aeroflot-cart]').removeClass('d-none');
            $('[data-radio-pay="online"]').prop('disabled', false);
            $('[data-order-text]').text('В ближайшее время с Вами свяжется сотрудник Интернет-магазина, чтобы уточнить время доставки.')
          }

          that.delivery = parseInt(price);

          that.totalPrice(that.sale, that.delivery)
        }
      }

      e.preventDefault()
    });

    this.saleEL.on('click', function() {
      let el = $(this);
      let sale = el.attr('data-delivery-sale');

      that.sale = sale;

      // that.totalPrice(that.sale, that.delivery);
    });

    this.cardCount.on('change', function(e) {
      let el = $(this);
      let quantity = this.value;
      let id = el.data('id');
      let productId = el.data('product-id');

      if ($('[data-preloader]').length > 0) {
        $('[data-preloader]').show();
      }

      $.post('/local/ajax/changeSKU.php', {
        sessid    : $('#sessid').val(),
        action    : 'quantity',
        ID        : id,
        productId : productId,
        QUANTITY  : quantity
      }).done(function() {
        submitForm(function() {
          // flocktory
          if (typeof window.gtm_cart_items !== 'undefined') {
            that.flocktoryUpdateCart(window.gtm_cart_items);
          }
        });

      });


      e.preventDefault();
    });

    this.cardRemove.on('click', function(e) {
      that.card = that.cart.find('[data-card]');
      // that.totalPrice(that.sale, that.delivery);

      e.preventDefault();
    });

    this.cardChangeSize.on('click', function(e) {

      if ($('[data-preloader]').length > 0) {
        $('[data-preloader]').show();
      }

      let id = $(this).data('id');
      let productId = $(this).data('product-id');
      let size = $(this).data('size');

      $.post('/local/ajax/changeSKU.php', {
        sessid    : $('#sessid').val(),
        action    : 'size',
        ID        : id,
        productId : productId,
        size      : size
      }).done(function() {
        submitForm(function() {
          // flocktory
          if (typeof window.gtm_cart_items !== 'undefined') {
            that.flocktoryUpdateCart(window.gtm_cart_items);
          }
        });
      });
    });

    this.accessories.on('click', function(e) {
      let el = $(this);

      let id = el.attr('data-id');

      if ($('[data-preloader]').length > 0) {
        $('[data-preloader]').show();
      }

      $.post('/local/ajax/addtobasket.php', {
        sessid   : $('#sessid').val(),
        action   : 'ADD2BASKET',
        quantity : 1,
        id       : id
      }, function() {
        submitForm();
      }, 'json');

      e.preventDefault();
    });

    this.fittingSizesAdd.on('click', function(e) {

      let check = $(this).prop('checked');
      let id = $(this).attr('data-id');

      if ($('[data-preloader]').length > 0) {
        $('[data-preloader]').show();
      }

      $.post('/local/ajax/changeSKU.php', {
        sessid : $('#sessid').val(),
        action : 'check',
        ID     : id,
        check  : check
      }).done(function() {

        submitForm();

      });

    });

    // адрес доставки курьером, все поля
    $('body').on('keyup blur', '.js-delivery-address', function(e) {
      that.checkCurierAddress();
    });

    this.deliveryType.on('change', function() {
      $('#ORDER_PROP_' + window.orderProps['STORE_ID']).val('');
      $('#ORDER_PROP_' + window.orderProps['F_ADDRESS']).val('');
      if($('[name="DELIVERY_ID"]:checked').attr('data-curier-delivery') == 'Y'){
        that.checkCurierAddress();
      }
      submitForm();
    })

    this.paysystemType.on('change', function() {
      submitForm();
    })

    this.cardRemove.on('click', function(e) {
      let el = $(this);

      let id = $(this).data('id');

      // el.closest('[data-card]').remove()

      if ($('[data-preloader]').length > 0) {
        $('[data-preloader]').show();
      }

      $.post('/local/ajax/remove_from_basket.php', {
        sessid : BX.bitrix_sessid(),
        id     : id
      }, 'json').done(function(newCart) {

        el.closest('[data-card]').remove()

        if ($('[data-preloader]').length > 0) {
          $('[data-preloader]').hide();
        }

        // gtm, flocktory
        if (typeof window.gtm_cart_items !== 'undefined') {
          let item_gtm = window.gtm_cart_items.find((item) => {
            return item.id == id
          });

          if (typeof item_gtm !== 'undefined') {
            dataLayer.push({
              'event'     : 'removeFromCart',
              'ecommerce' : {
                'remove' : {
                  'products' : [
                    {
                      'name'     : item_gtm.name,
                      'id'       : item_gtm.product_id,
                      'price'    : item_gtm.price,
                      'brand'    : item_gtm.brand,
                      'category' : item_gtm.category,
                      'variant'  : item_gtm.variant,
                      'quantity' : 1
                    }
                  ]
                }
              }
            });
          }
        }

        submitForm(function() {
          // flocktory
          if (typeof window.gtm_cart_items !== 'undefined') {
            that.flocktoryUpdateCart(window.gtm_cart_items);
          }
        });
      }).fail(function(response) {
        if (process.env.NODE_ENV === 'development') {
          el.closest('[data-card]').remove()
        }
      });

      e.preventDefault();
    });

    // Выпадающая панель с поисковыми подсказками у поля ввода улицы.
    if (typeof ymaps != 'undefined') {
      ymaps.ready(function() {

        var suggestView = new ymaps.SuggestView('courierStreet', {
          provider: {
            suggest : (function(request, options) {
              return ymaps.suggest($('#location_name').attr('data-city-name') + ", " + request).then(items => {
                let arrayResult = [];
                let places = [];
                items.forEach(i => {
                  i.displayName = i.displayName.split(',')[0];
                  i.value = i.displayName.split(',')[0];
                  if (!places.includes(i.displayName)) {
                    places.push(i.displayName);
                    arrayResult.push(i);
                  }
                });

                return ymaps.vow.resolve(arrayResult);
              });
            })
          }
        });
        suggestView.events.add("select", function(e) {
          that.checkCurierAddress();
        });
      });
    }

    $('.card-cart__images, .card-cart__title a').on('click', function(e) {
      let that = $(this);
      let card = that.closest('[data-card]');
      let id = card.find('[data-id]').data('id');

      if (typeof window.gtm_cart_items !== 'undefined') {
        let item_gtm = window.gtm_cart_items.find((item) => {
          return parseInt(item.id) == parseInt(id)
        });

        if (typeof item_gtm !== 'undefined') {
          dataLayer.push({
            'ecommerce'                    : {
              'click' : {
                'actionField' : {'list' : 'Cart'},
                'products'    : [
                  {
                    'name'     : item_gtm.name,
                    'id'       : item_gtm.product_id,
                    'price'    : item_gtm.price,
                    'brand'    : item_gtm.brand,
                    'category' : item_gtm.category,
                    'variant'  : item_gtm.variant,
                    'position' : item_gtm.position
                  }
                ]
              }
            },
            'event'                        : 'gtm-ee-event',
            'gtm-ee-event-category'        : 'Enhanced Ecommerce',
            'gtm-ee-event-action'          : 'Product Clicks',
            'gtm-ee-event-non-interaction' : 'False',
          });
        }
      }
    });
    // this.totalPrice(this.sale, this.delivery)
  }

  checkCurierAddress() {
    let $addressInput = $('#ORDER_PROP_' + window.orderProps['F_ADDRESS']);

    let $address = [];
    $('.js-delivery-address').each(function(i, el) {
      if ($(el).val().length > 0) {
        var text = $(el).val();
        $address.push($(el).attr('data-text') + text);
      }
    });

    $address = $address.join(', ');

    $addressInput.val($address);
  }

  /**
   * Метод отправляет состояние корзины во Flocktory
   * @param cart
   */
  flocktoryUpdateCart(cart = []) {
    if (cart.length > 0) {
      let flocktoryCartItemsUpdate = [];
      cart.forEach(function(item) {
        flocktoryCartItemsUpdate.push({
          'id'    : item.product_id,
          'price' : parseFloat(item.price),
          'count' : parseInt(item.quantity)
        });
      });

      window.flocktory = window.flocktory || [];
      window.flocktory.push([
        'updateCart', {
          cart : {
            items : flocktoryCartItemsUpdate
          }
        }
      ]);
    }
  }

  initializeMiniCart() {
    let that = this;
    let intCartCount = parseInt($('[data-cart-count]').text());

    if(intCartCount <= 0){
      $('[data-cart-count]').addClass('d-none')
    }else{
      $('[data-cart-count]').removeClass('d-none')
    }

    // Показываем мини корзину
    $('[data-mini-card-icon]').on('mouseenter', function(e) {
      e.stopPropagation();
      if(intCartCount > 0){
        $('[data-header-cart]').addClass('visible')
      }
    });


    this.cart.on('click', function(e) {
      e.stopPropagation();
    })

    //Скрываем мини коризну если клик был вне неё
    $('body').on('click', function(e){ // событие клика по веб-документу
      $('.header-card').removeClass('visible');
    });

    $('[data-continue-shopping]').on('click', function(e) {
      e.preventDefault();
      $('[data-header-cart]').removeClass('visible')
    })

    // окно корзины по-умолчнаию скрываем, показываем если в корзине есть товары
    that.card = that.cart.find('[data-card]');
    if (that.card.length > 0) {
      that.cart.removeClass('d-none');
    }

    this.product.find('button').on('click', function() {
      $(this).closest('[data-product-size]').find('button').removeClass('active');
      $(this).addClass('active');
    });

    $(document).on('click', '[data-fast-order-popup]', function (e) {

      e.preventDefault();
      let productId = $('[data-popup-product]').attr('data-popup-product-id')
      let $fastBuyModal = $('#popup-one-click')

      // очистить предыдущие значения
      $fastBuyModal.find('.js-coupon-form').hide();
      $fastBuyModal.find('.js-discount').text('0');
      $fastBuyModal.find('.js-coupon-value').val('');

      // запрос стоимости доставки

      if (window.xhr_fast_order && window.xhr_fast_order.readyState != 4){
        window.xhr_fast_order.abort();
      }
      window.xhr_fast_order = $.post('/local/ajax/buy_one_click.php', {type: 'deliveryPrice', id: productId}, null, 'json')
        .done(function(result) {
          $.magnificPopup.open({
            items: {
              src: '#popup-one-click'
            },
            type:'inline',
            midClick: true,
            closeMarkup: '<button title="%title%" type="button" class="mfp-close popup__close close"></button>',
            removalDelay: 500, //delay removal by X to allow out-animation
            callbacks: {
              beforeOpen: function() {
                this.st.mainClass = 'mfp-zoom-in';
              }
            }
          });
          if (result.success) {
            var deliveryPrice = parseFloat(result.data);
            var orderSum = parseFloat($fastBuyModal.find('.js-order-total').data('order-sum'));
            $fastBuyModal.find('.js-delivery-cost').data('delivery-price', deliveryPrice);
            // доставка 0, если сумма заказа более 10000
            if (orderSum >= 10000) {
              deliveryPrice = 0;
            }
            $fastBuyModal.find('.js-delivery-cost').text(deliveryPrice);
            $fastBuyModal.find('.js-order-total').text(orderSum + deliveryPrice);
          }
        });

    })


    this.cardCount.on('change', function(e) {
      let el = $(this);
      let count = this.value;
      let id = el.data('id');
      let productId = el.data('product-id');

      $.post('/local/ajax/changeSKU.php', {
        sessid    : $('#sessid').val(),
        action    : 'quantity',
        ID        : id,
        productId : productId,
        QUANTITY  : count
      }).done(function() {

        that.selectCount(el, count);
        // that.totalPriceMini();
        that.refreshMiniCart(function() {
          if (typeof window.gtm_cart_items !== 'undefined') {
            that.flocktoryUpdateCart(window.gtm_cart_items);
          }
        });

      });

      e.preventDefault();
    });

    this.cardRemove.on('click', function(e) {
      let id = $(this).data('id');

      $.post('/local/ajax/remove_from_basket.php', {
        sessid : BX.bitrix_sessid(),
        id     : id
      }, 'json').done(function() {

        // gtm
        if (typeof window.gtm_cart_items !== 'undefined') {
          if (typeof item_gtm !== 'undefined') {
            dataLayer.push({
              'event'     : 'removeFromCart',
              'ecommerce' : {
                'remove' : {
                  'products' : [
                    {
                      'name'     : item_gtm.name,
                      'id'       : item_gtm.product_id,
                      'price'    : item_gtm.price,
                      'brand'    : item_gtm.brand,
                      'category' : item_gtm.category,
                      'variant'  : item_gtm.variant,
                      'quantity' : 1
                    }
                  ]
                }
              }
            });
          }
        }

        that.refreshMiniCart(function() {
          if (typeof window.gtm_cart_items !== 'undefined') {
            that.flocktoryUpdateCart(window.gtm_cart_items);
          }
        });
      });

      that.card = that.cart.find('[data-card]');
      // that.totalPriceMini();
      that.cartCount.text(that.card.length)
      that.cartCount.attr('data-cart-count', that.card.length)

      e.preventDefault();
    });

    // this.totalPriceMini()
  }

  /**
   * Метод обновляет корзину в хедере
   */
  refreshMiniCart(callback) {
    let that = this;

    $.get(that.url, function(response) {
      let $response = $(response);
      let cartCount = $response.find('[data-cart-count]');
      let intCartCount = parseInt(cartCount.data('cart-count'));
      let cartList = $response.find('[data-header-cart]');

      that.cartCount.text(intCartCount); // число товаров в корзине для хедера
      that.cartCount.attr('data-cart-count', intCartCount); // число товаров в корзине для хедера
      that.cart.replaceWith(cartList[0].outerHTML); // список товаров в корзине для хедера

      if(intCartCount <= 0){
        $('[data-header-cart]').removeClass('visible');
        cartCount.addClass('d-none')
      }

      let minicart = [];
      $('[data-mini-card-icon]').off('mouseenter');

      if ($('[data-header-cart]').length > 0) {
        $('[data-header-cart]').each(function(i) {
          minicart[i] = new Cart($(this));
          minicart[i].initializeMiniCart();
        });
      }

      if (typeof callback == 'function') {
        callback();
      }
    });
  }

  selectCount(el, count) {
    let card = el.closest('[data-card]');
    let cardPrice = card.find('[data-card-price]');

    let price = parseInt(cardPrice.text().replace('₸', '').replace(/\s/g, ''));
    let priceTotal = price * count;

    cardPrice.attr('data-card-price', priceTotal);
  }

  totalPrice(sale, delivery) {
    if(sale === undefined || delivery === NaN) {
      return;
    }
    let saleEl = $('[data-total-sale]');
    let totalEl = $('[data-total-price]');
    let card = this.card;
    let priceCard = 0;
    let total = 0;

    card.each(function() {
      let el = $(this);
      let price = parseInt(el.find('[data-card-price]').attr('data-card-price').replace('₸', '').replace(/\s/g, ''));

      priceCard += price;
    });

    sale = parseInt(sale.replace('%', ''));
    sale = parseInt(priceCard * sale / 100);

    total = priceCard - sale + delivery;

    saleEl.text(sale);
    totalEl.text(total.toLocaleString() + ' ₸');
  }

  totalPriceMini() {
    let totalEl = $('[data-total-price-mini]');

    let card = this.card;
    let total = 0;

    card.each(function() {
      let el = $(this);
      let price = parseInt(el.find('[data-card-price]').attr('data-card-price').replace('₸', '').replace(/\s/g, ''));
      let count = parseInt(el.find('[data-delivery-product-count]').val());
      total += count * price;
    });

    totalEl.text(total.toLocaleString() + ' ₸');
  }

}

export {Cart};

$(function () {
  window.Cart = Cart;
});

$(window).on('load', () => {
  let product = [];
  let carts = [];
  let minicart = [];

  if ($('[data-product]').length > 0) {
		$('[data-product]').each(function(i) {
			product[i] = new Cart($(this));
			product[i].initialize();
		});
	}

  if ($('[data-cart]').length > 0) {
		$('[data-cart]').each(function(i) {
			carts[i] = new Cart($(this));
			carts[i].initializeCart();
		});
	}

  $('[data-mini-card-icon]').off('mouseenter');
  if ($('[data-header-cart]').length > 0) {
		$('[data-header-cart]').each(function(i) {
			minicart[i] = new Cart($(this));
      minicart[i].initializeMiniCart();

      if(typeof window.gtm_cart_items !== 'undefined' && window.isFlocktoryUpdateCart === true){
        minicart[i].flocktoryUpdateCart(window.gtm_cart_items);
      }
		});
	}
});
